export default __webpack_public_path__ + "static/first-5328ae20c9d6748e5c8ab28dd42409e2.png";